"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isView = void 0;
var isView = function (x) {
    return (
    // @ts-ignore
    x && typeof x === "function" && typeof x.isView === "boolean" && x.isView);
};
exports.isView = isView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNWaWV3LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2lzVmlldy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBTyxJQUFNLE1BQU0sR0FBRyxVQUFDLENBQVU7SUFDL0IsT0FBTztJQUNMLGFBQWE7SUFDYixDQUFDLElBQUksT0FBTyxDQUFDLEtBQUssVUFBVSxJQUFJLE9BQU8sQ0FBQyxDQUFDLE1BQU0sS0FBSyxTQUFTLElBQUksQ0FBQyxDQUFDLE1BQU0sQ0FDMUUsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUxXLFFBQUEsTUFBTSxVQUtqQiJ9